import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support-center',
  templateUrl: './support-center.component.html',
  styleUrls: ['./support-center.component.scss']
})
export class SupportCenterComponent implements OnInit {
  role = localStorage.getItem('role');

  ngOnInit() {}
}
